// Bookie · Marjon — variant that renders the standalone HTML template
// (SUMMER POOL PARTY BIRTHDAY on cream paper, Fraunces display +
// Newsreader italic body + an Allura script accent, an abstract
// coral-branch line-art at the top of HERO and tiny coral fragments
// between sections). The HTML lives at /templates/bookie-coral.html
// and is fully self-contained; we hand it the invitation payload
// through the iframe URL because postMessage would race the
// customizer's pre-paint text-node walk.
//
// Birthday convention: `t.names` carries "Celebrant · Age" (e.g.
// "Mohira · 28"). The HTML customizer splits on " · " and substitutes
// celebrant + age tokens independently.

import type { VariantProps } from "./types";
import { getLocale } from "@/lib/i18n";

const TEMPLATE_HTML = "/templates/bookie-coral.html";

export function BookieCoralStaticVariant({ t, ctx }: VariantProps) {
  const params = new URLSearchParams();
  if (t.names) params.set("names", t.names);
  if (t.date) {
    // Pass the original dd.mm.yyyy through — the customizer matches
    // dd.mm.yyyy literally against the mock string inside the HTML
    // ("05.07.2026"), so we skip the normalization round-trip.
    params.set("date", t.date);
  }
  if (t.venue) params.set("venue", t.venue);
  if (t.address) params.set("address", t.address);
  if (t.time) params.set("time", t.time);
  if (ctx.slug) params.set("slug", ctx.slug);
  if (t.musicTrackId) params.set("audio", "/music/" + t.musicTrackId + ".mp3");
  // Cache buster — bump when the static HTML changes.
  params.set("v", "3");

  // Demo/catalog preview (no real invitation slug): default the template's
  // in-iframe language to the app locale, so taklifla.com previews render in
  // English (and a RU viewer sees Russian). The HTMLs read ?lang= (all) and
  // ?default_lang= (newer premium ones) — set both. Owner-published
  // invitations (ctx.slug set) keep their own default_lang / built-in default.
  if (!ctx.slug) {
    const _loc = getLocale();
    if (!params.has("lang")) params.set("lang", _loc);
    if (!params.has("default_lang")) params.set("default_lang", _loc);
  }
  const src = `${TEMPLATE_HTML}?${params.toString()}`;

  return (
    <iframe
      src={src}
      title={t.names || "Mohira · 28"}
      style={{
        position: "fixed",
        inset: 0,
        width: "100vw",
        height: "100svh",
        border: "none",
        display: "block",
        background: "#FBF6EC",
      }}
    />
  );
}
